<template>
    <div class="modal-overlay">
        <div class="modal-content max-width-800">
            <div class="panel-title">
                <span>
                    <i :class="getFeatureIcons('mos')"></i>
                    <span> {{ getFeatureNames('mos') }} - {{ this.symbol }}</span>
                </span>
                <span @click="closePanel"><i class="cursor-pointer ti-close right-side-toggle medium-icon"></i></span>
            </div>
            <div class="card card-body">
                <div>
                    <ul class="nav nav-tabs customtab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'general' }"
                                @click="() => onSelectedTab('general')">
                                <i class="fas fa-adjust"></i>
                                <span class="hidden-sm-up"> {{ $t('stocks.general.title') }}</span>
                                <span class="hidden-xs-down"> {{ $t('stocks.general.title') }}</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === '10x' }"
                                @click="() => onSelectedTab('10x')">
                                <i class="fas fa-hand-holding-usd"></i>
                                <span class="hidden-sm-up"> {{ $t('stocks.ten_x_income.title') }}</span>
                                <span class="hidden-xs-down"> {{ $t('stocks.ten_x_income.title') }}</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'dcf' }"
                                @click="() => onSelectedTab('dcf')">
                                <i class="fas fa-tag"></i>
                                <span class="hidden-sm-up"> {{ $t('stocks.dcf.title') }}</span>
                                <span class="hidden-xs-down"> {{ $t('stocks.dcf.title') }}</span>
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane" :class="{ active: this.selectedTab === 'general' }">
                            <div class="card-body">
                                <general />
                            </div>
                        </div>
                        <div class="tab-pane" :class="{ active: this.selectedTab === '10x' }">
                            <div class="card-body">
                                <e10xIncome />
                            </div>
                        </div>
                        <div class="tab-pane" :class="{ active: this.selectedTab === 'dcf' }">
                            <div class="card-body">
                                <dcf />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoadingContainer from "@/components/Misc/LoadingContainer";
import common from "@/libs/common";
import General from '../Evaluation/General';
import Dcf from '../Evaluation/Dcf';
import E10xIncome from '../Evaluation/10xIncome';

export default {
    components: {
        LoadingContainer,
        General,
        Dcf,
        E10xIncome
    },
    props: {
        symbol: {
            type: String,
            default: ''
        }
    },
    beforeMount() {

    },
    data() {
        return {
            selectedTab: "general"
        }
    },
    computed: {
        ...mapGetters({
            form: "evaluation/form",

        }),
    },
    methods: {
        ...mapActions({

        }),
        getFeatureNames(name) {
            return common.getFeatureNames(name);
        },
        getFeatureIcons(name) {
            return common.getFeatureIcons(name);
        },
        onSelectedTab(key) {
            this.selectedTab = key;
        },
        closePanel() {
            this.$emit('close');
        }
    }
}
</script>